import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'

// import guia_android from './guias_cat/guia_android.pdf';
// import guia_chrome from './guias_cat/guia_chrome.pdf';
// import guia_edge from './guias_cat/guia_edge.pdf';
// import guia_firefox from './guias_cat/guia_firefox.pdf';
// import guia_ios from './guias_cat/guia_ios.pdf';
import { getNavigator, getUrlGuia } from '../../helpers';
import { ModalInfo } from '../../components/ModalInfo/ModalInfo';
import { Button, Grid } from '@mui/material';


const ModalPlugin = ({ dataModal_InfoPlugin, handleCloseModal_InfoPlugin, pki }: any) => {

    const handleClickInstallPlugin = (_: any) => {
        pki.redirectToInstallPage();
    }

    const nameNavigator = getNavigator()?.split(' ')[0]

    let guia: any = null

    if (nameNavigator === 'Chrome') {

        guia = '/guias/guias_cat/guia_chrome.pdf'

    } else if (nameNavigator === 'Firefox') {

        guia = '/guias/guias_cat/guia_firefox.pdf'

    } else if (nameNavigator === 'Edg') {

        guia = '/guias/guias_cat/guia_edge.pdf'

    } else {

        guia = '/guias/guias_cat/guia_chrome.pdf'
    }

    const guiaName = getUrlGuia(nameNavigator)

    const [show, setshow] = useState(false)

    const handleDownload = (guia: any) => {
        const link = document.createElement("a");
        link.href = guia;
        link.setAttribute("download", 'guia.pdf'); // fuerza descarga
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <ModalInfo
                data={dataModal_InfoPlugin}
                handleClose={handleCloseModal_InfoPlugin}
                width={980}
                message={
                    <div>

                        <div className="modal-body p-4" id="instalarPlugin-content">
                            <Grid container spacing={3} justifyContent="center" >
                                <Grid item xs={12} className="pt-0">

                                    <h3 className="text-center my-2">Signatura de documents</h3>
                                    <p className="text-center mb-2">
                                        Per poder continuar amb el procés de signatures, si us plau
                                        descarregueu i instal·leu el plugin
                                    </p>


                                </Grid>
                                <Grid item xs={12} lg={6} xl={6} className="pt-0">
                                    <div className="card px-2 px-lg-3 shadow-sm">
                                        <h3 className="text-center">Plugin de Firma</h3>
                                        <ul className='text-left'>
                                            <li className="my-2">
                                                <small>No cal descarregar els documents per signar-los.</small>
                                            </li>
                                            <li className="my-2">
                                                <small>Pots signar múltiples documents alhora.</small>
                                            </li>
                                            <li className="my-2">
                                                <small>Podràs afegir marques d'aigua de manera personalitzada.</small>
                                            </li>
                                            <li className="my-2">
                                                <small>Agilitza el procés de signatura.</small>
                                            </li>
                                        </ul>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            className='mt-2'
                                            onClick={handleClickInstallPlugin}
                                        >
                                            Descarregar i instal·lar Plugin
                                        </Button>
                                    </div>
                                </Grid>

                                <Grid item xs={12} lg={6} xl={6} className="pt-0">
                                    <div className="px-3">
                                        <strong className="d-block my-3">Com instal·lar el plugin?</strong>
                                        <p>Si teniu problemes sobre el connector, baixeu la guia d'instal·lació.</p>
                                        
                                        <Button
                                            color="primary"
                                            variant="outlined"
                                            className='mt-2'
                                            id="btn-guia"
                                            onClick={() => handleDownload(guia)}
                                        >
                                            <FontAwesomeIcon icon={faFilePdf} style={{marginRight: '.7rem'}} /> Guia d'instal·lació
                                        </Button>

                                        <div>
                                            <div id="otras-guias" className="d-inline-block mt-4 mb-3 pointer" onClick={() => setshow(!show)}>Veure altres guies</div>
                                            {
                                                show && <div className="d-flex flex-column" id="otras-guias-links">
                                                    {!(guiaName === 'guia_chrome') && <a href={'/guias/guias_cat/guia_chrome.pdf'} id="guia_chrome" download="" className='color-primary my-2'>Guia Google Chrome</a>}
                                                    
                                                    {!(guiaName === 'guia_firefox') && <a href={'/guias/guias_cat/guia_firefox.pdf'} id="guia_firefox" download="" className='color-primary my-2'>Guia Mozilla Firefox</a>}
                                                    
                                                    {!(guiaName === 'guia_edge') && <a href={'/guias/guias_cat/guia_edge.pdf'} id="guia_edge" download="" className='color-primary my-2'>Guia Microsoft Edge</a>}
                                                    {/* {!(guiaName === 'guia_android') && <a href={'/guias/guias_cat/guia_android.pdf'} id="guia_android" download="">Guia Mòbils Android</a>}
                                                    {!(guiaName === 'guia_ios') && <a href={'/guias/guias_cat/guia_ios.pdf'} id="guia_ios" download="">Guia Mòbils IOS</a>} */}

                                                </div>
                                            }

                                        </div>
                                    </div>
                                </Grid>
                            </Grid>

                        </div>
                        <div className="modal-body p-4 d-none" id="content-descargar-navegador">
                            <h3 className="text-center my-4">Signatura de documents</h3>
                            <p className="text-center mb-4">El vostre navegador no és compatible amb el Plugin, si us plau utilitzeu un dels següents navegadors per continuar amb el procés de signatura</p>
                            <div className="d-flex justify-content-center flex-wrap mb-4">
                                <a href="https://www.google.com/intl/es/chrome/" className="m-3 d-flex flex-column align-items-center">
                                    {/* <FontAwesomeIcon icon={faChrome} /> */}
                                    <span>Google Chrome</span>
                                </a>
                                <a href="https://www.mozilla.org/es-ES/firefox/new/" className="m-3 d-flex flex-column align-items-center">
                                    {/* <FontAwesomeIcon icon={faFirefox} /> */}
                                    <span>Mozilla Firefox</span>
                                </a>
                                <a href="https://www.microsoft.com/es-es/edge" className="m-3 d-flex flex-column align-items-center">
                                    {/* <FontAwesomeIcon icon={faEdge} /> */}
                                    <span>Microsoft Edge</span>
                                </a>
                            </div>
                        </div>
                    </div>
                }
            />
        </>
    )
}

export default ModalPlugin